import React, { useState } from "react";
import { pdTranslations } from "../translation/pd";
import GenZInfoPanel from "../GenZInfoPanel";

const PDGenZStats = ({
  selectedLanguage,
  role,
  currentTheme, 
}) => {
  const [showGenInfo, setShowGenInfo] = useState(false);
  const [showIndiaStats, setShowIndiaStats] = useState(false);

  const t = (key) =>
    pdTranslations?.[selectedLanguage]?.[key] ??
    pdTranslations?.["en"]?.[key] ??
    key;

  // console.log("PDGenZStats received:", { selectedLanguage, role });
  return (
    <div className="space-y-6 bg-gray-900 p-6 rounded-xl text-white border-t-2 border-cyan-200 mt-2">
      <div
        onClick={() => setShowGenInfo((prev) => !prev)}
        className="
          cursor-pointer
          rounded-xl
          border border-purple-500/40
          bg-gradient-to-r
          from-purple-700
          via-fuchsia-600
          to-indigo-700
          px-4 py-3
          shadow-lg
          hover:scale-[1.01]
          transition-all
        "
      >
        <div className="flex flex-col items-center justify-center">
          <div className="font-bold text-white text-sm lg:text-base">
            {t("t1")}
          </div>

          <div className="text-purple-100 text-xs">
            {t("t2")} {showGenInfo ? "▲" : "▼"}
          </div>

          <div className="text-purple-100 text-xs mt-1">
            {t("t3")}
          </div>
        </div>
      </div>

      {showGenInfo && (
        <GenZInfoPanel
          selectedLanguage={selectedLanguage}
          showIndiaStats={showIndiaStats}
          setShowIndiaStats={setShowIndiaStats}
        />
      )}
    </div>
  );
};

export default PDGenZStats;